$(document).ready(function () {
  if($(window).width() <= 767) {
    var getImageSrc = $('.home-slider .slide-item .slide-img img').attr('src');

    $('.home-slider .slide-item .slide-img').css('background-image', 'url(' + getImageSrc + ')');
  }
  index_js();
  set_tabbing_collection();
  compete_look_slider();
  thumbail_prdbox();
  product_infotab();    
  product_qunatity_updown();
  sticky_sidebar();
  faq_tabing();

  function contactform(){
    console.log('form')
    if($('.globo-formbuilder').find('.globo-form-app').length > 0 ){
      console.log('exit');
      return false;
    }
    else{
      console.log('rec')
    	return contactform();
    }
//     $('.action.submit.classic-button').on('click',function(e){
//       console.log('aaaa');
//       if($('.classic-input').val() == '' ){
//         alert('no')
//         return false;
//       }
//     });
  }
// contactform();
//    $(window).scroll(function() {
//     if($('.instagram').length == 1 ){
//       var hT = $('.instagram').offset().top,
//           hH = $('.instagram').outerHeight(),
//           wH = $(window).height(),
//           wS = $(this).scrollTop();
//       console.log(hT,hH,wH,wS);
//       console.log((hT-wH) , wS);
//       if ((wS > hT) && (wS < hT+hH)) {
//         setTimeout(initCounter, 100);
//       }
//     }
//   });
});
function faq_tabing(){
  jQuery(".faq-tabtitle").on('click', function () {
    $(this).parent("li").find(".faq-qtspara").slideToggle();
    $(this).parent("li").toggleClass("active-tab");
    $(this).toggleClass('eg-pls-opened');
  });    
}
function sticky_sidebar(){
  jQuery(window).scroll(function(){ 
    jQuery('.sidebar-leftwrap').css('top','30px');  
  });
}
function product_qunatity_updown(){
  var zr_incrementval = 1;
  var zr_decrementval = 1;

  $(document).on('click', '#prd-qty-plus', function(){
    var fetch_qtyval = parseInt($("#prd-qty-text").val() );
    fetch_qtyval = fetch_qtyval + zr_incrementval;
    $("#prd-qty-text").val(fetch_qtyval);
  });
  $(document).on('click', '#prd-qty-minus', function(){
    var fetch_qtyval = parseInt($("#prd-qty-text").val() );
    if(parseInt( $("#prd-qty-text").attr("min") ) >= $("#prd-qty-text").val() ){
      return false;
    }else{
      fetch_qtyval = fetch_qtyval - zr_incrementval;
      $("#prd-qty-text").val(fetch_qtyval);
    }
  });
}
function product_infotab(){
  $(".prd-rdes-tab li").on("click", function(){
    var fetch_tabtn = $(this).attr("data-tabtn");
    var fetch_tabcnt = $(this).parents(".prd-rdesc-tabinfo").find(".prd-rdes-info ul").attr("data-tabcnt");        

    $(".prd-rdes-tab li").removeClass("prd-active-tab");
    $(this).addClass("prd-active-tab");
    $(this).parents(".prd-rdesc-tabinfo").find(".prd-rdes-info").find("ul").each(function(){
      var fetch_tabcont = $(this).attr("data-tabcnt");
      if(fetch_tabcont == fetch_tabtn){
        $(this).addClass("active-block");
      }else{
        $(this).removeClass("active-block");
      }
    });
  });    
}
function thumbail_prdbox(){
  $('.prd-top-lookzooming').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.prd-btm-thumbail',
    responsive: [
      {
        breakpoint: 767,
        settings: {
          asNavFor: null,
          dots:true,
          fade: false,
        }
      }
    ]
  });
  $('.prd-btm-thumbail').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    asNavFor: '.prd-top-lookzooming',
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          asNavFor: null,
        }
      }
    ]
  });
}
function compete_look_slider(){
  $('.prd-complook-slider, .prd-recomnded-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 359,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
}
function set_tabbing_collection(){

  jQuery(".cl-cfg-head").on('click', function () {
    $(this).parent(".cl-cfg-box").find(".cl-cfg-menu").slideToggle();
    $(this).toggleClass('eg-pls-opened');
  });

}
function index_js(){
  $('.home-slider').slick({
    arrows: true,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false
  });

  $('.featured-product-slider').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1081,
        settings: {
          slidesToShow: 3
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 359,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
  $('.insta-gallery').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      }
    ]
  });
  $('.blog-gallery').slick({
    arrows: true,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          arrows: false
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          arrows: false
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          arrows: false
        }
      }
    ]
  });
  $('.nav-opener').click(function (e) {
    $('.site-header .navigation').addClass('open');
    $('body').addClass('nav-active');
  });
  $('.nav-close').on("click", function (e) {
    $(".navigation").removeClass("open");
    $('body').removeClass('nav-active');
  });
  settings = {
    //Model Popup
    objModalPopupBtn: ".modalButton",
    objModalCloseBtn: ".overlay, .close",
    objModalDataAttr: "data-popup"
  }
  $(settings.objModalPopupBtn).bind("click", function () {
    if ($(this).attr(settings.objModalDataAttr)) {

      var strDataPopupName = $(this).attr(settings.objModalDataAttr);

      //Fade In Modal Pop Up
      $(".overlay, #" + strDataPopupName).fadeIn();
      $('body').addClass('modal-active');
    }
  });

  //On clicking the modal background
  $(settings.objModalCloseBtn).bind("click", function () {
    $(".modal").fadeOut();
    $('body').removeClass('modal-active');
  });
}; 
$("body").on('click',".mini-cart-icon",function(e){                                                  
  e.preventDefault();
  $('body').addClass('fullpage');
  addToCartSuccess();
});
function addToCartSuccess() {
  $.get( "/cart?view=mini", function( data ) {
    $('.minicart_content').html(data);
    $('.mini-cart-wrap').css('right','0');
    $('.close').css('right','24px');
  });
}
$('body').on('click', '.cartdataouter .box .adjust',function(){

  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  if($(this).hasClass('plus')) {
    ip += 1;
  } else {
    ip = ip - 1;
  }
  if(ip==0) {
    return false;
  }
  input.val(ip);
  console.log(ip)
  $('.cart-body').addClass('loading');
  var id = parseInt(input.attr('data-id'));
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates['+id+']='+ip,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      alert(response.description);
      $('.cart-body').removeClass('loading');
    }
  }).done(function(data) {
    addToCartSuccess();
    $.getJSON('/cart.js', function(c){
      $('.itemCount').text(c.item_count);
    });
    $.getJSON('/cart.js', function(c){
      var tp=c.original_total_price/100;
      var n=tp.toFixed(2);
      $('.js-ajax-cart-counter').text(c.item_count);
      $('.tprice').text('Rs. '+ n);
    });
    $('.cart-body').removeClass('loading');
  });

});
$("body").on('click','.remove_item', function(e){  
  $('.cart-body').addClass('loading');
  e.preventDefault();
  var id = $(this).data("id");
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates['+id+']='+0,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      alert(response.description);
      $('.cart-body').removeClass('loading');
    }
  }).done(function( data ) {
    $.getJSON('/cart.js', function(c){
      if(!c.item_count || c.item_count == 0) {
        $('.cart-body').empty();
        $('.cart-body').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');    
        $('.cart-body').removeClass('loading');

        var tp=c.original_total_price/100;
        var n=tp.toFixed(2);
        $('.js-ajax-cart-counter').text(c.item_count);
        $('.tprice').text('Rs. '+ n);
      } else {
        addToCartSuccess();
        var tp=c.original_total_price/100;
        var n=tp.toFixed(2);
        $('.js-ajax-cart-counter').text(c.item_count);
        $('.tprice').text('Rs. '+ n);
      }
    });
  });

});
$("body").on('click','.close', function(e){
  $('.mini-cart-wrap').css("right","-100%");
  $('.close').css('right','-24px');
  setTimeout(function(){
    $('body').removeClass('fullpage');
  },1000);
});
// $('body').on('click','#add-to-cart', function (event) {
//   event.preventDefault();
//   var form = $(this).closest('form');
//   var ok = false;
//   $('.error_msg').remove();
//   if(form.find('.swatchcom').length) {
//     form.find('.swatchcom').each(function(){
//       console.log($(this).find('input:checked').length);
//       if($(this).find('input:checked').length==0) {
//         alert('0');
//         ok = true;
//         console.log('ok=='+ok);
//         var name = $(this).attr('data-name');
//         $('.swatchcom').append('<p class="error_msg">Please select '+ name +'</p>');
//         return false;
//       }
//     });
//     if(ok) {
//       return false;
//     }
//   }
// });
$(document).ready(function(){
  var arr = [];

  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  function set_cookie(arrs){
    document.cookie = 'arr=' + arrs + ';expires="1";path=/';
  }

  $('body').on('click','.compare_btn',function(e){
    $('.featured_compare').addClass('active');
    e.preventDefault();
    var handle = $(this).data('handle');
    $.getJSON('/products/'+ handle +'.js', function(product) {

      var img = product.featured_image;
      var price = product.price;
      var title = product.title;
      var mf = "";
      var html = '<div class="img"><a href="#"><img src="'+img+'" width="270px" height="360px"></a></div>';
      html+= '<div class="product-content"><h4><a href="#">'+product.title+'</a></h4>';
      html+= '<p>'+product.price+'</p></div><a href="#" class="compare_close" data-handle="'+ product.handle +'">x</a>';
      var cookie_arr = getCookie('arr');
      if(cookie_arr != null){
        cookie_arr = cookie_arr.split(',');
      }
      alert(cookie_arr + 'sssss' )
      if (arr.length <= 3 || cookie_arr.length <= 3 ) {
        arr.push(product.handle);
        set_cookie(arr)
        $('.compare_common').each(function(i,v){
          if($(v).hasClass('blank')){
            $(v).append(html);
            $(v).removeClass('blank');
            return false;
          }
        });
      };
    });
  });
  $('body').on('click','.comapre_all',function(){
    var com_arr = getCookie('arr');
    com_arr = com_arr.split(',');
    if(com_arr.length < 2){
      alert('please check at least 2 products... ')
      return false;
    }
  });
  $('body').on('click','.compare_close',function(e){
    e.preventDefault();
    var h = $(this).attr('data-handle');
    $(this).closest('.compare_common').addClass('blank');
    $(this).closest('.compare_common').empty();

    var lists = getCookie('arr');
    lists = lists.split(',');
    var up_lists = $.grep(lists,function(list){
      return list != h;
    });
    arr = $.grep(arr,function(arr_item){
      return arr_item != h;
    });
    set_cookie(up_lists);
  });
});

// function currencyFormSubmit(event) {
//   event.target.form.submit();
// }

// document.querySelectorAll('.shopify-currency-form select').forEach(function(element) {
//   element.addEventListener('change', currencyFormSubmit);
// });

$(document).ready(function(){
  var widthitem = 100; 
  $(".arrow-left").click(function(){
    $(".items").animate({scrollLeft: "-="+widthitem});
  });
  $(".arrow-right").click(function(){
    $(".items").animate({scrollLeft: "+="+widthitem});
  }); 

  //   $('.product_form').on('click',function(){
  //     var p = $(this).data('handle');
  //     $('#proname').val(p);
  // 	$('#contact_wrapper').css('display','block');
  //   });
  //   $('.close-button').on('click',function(){
  //   	$('#contact_wrapper').css('display','none');
  //   });
  $("body").on('click',".quick-viewc",function(e){                                                  
    e.preventDefault();
    $('body').addClass('fullpage');
    var href=$(this).data('href');
    $.get( href, function( data ) {
      $('.quickview_content').html(data);
    });
  });
});
// [].forEach.call(document.querySelectorAll('.product_form'), function(el){
//   el.addEventListener("click",function(e) {
//     alert(el)
//     var a = document.querySelector('#contact_wrapper');
//     a.style.display="block";
//     var val = document.querySelector('.product_form').getAttribute("data-handle");
//     document.querySelector('#proname').value = val;
//     a.classList.remove('active');
//   });
// });

// document.querySelector('.close-button').addEventListener("click",() => {
//  var b = document.querySelector('#contact_wrapper');
//  b.style.display="none";
//  b.classList.add('active');
// });

// FB.ui({
//   method: 'send',
//   link: 'http://www.nytimes.com/interactive/2015/04/15/travel/europe-favorite-streets.html',
// });

// // window.open('fb-messenger://share?link=' + encodeURIComponent(link) + '&app_id=' + encodeURIComponent(app_id));
// document.querySelector('.consultation_btn').addEventListener("click",(e) => {
//   e.preventDefault();
//   document.querySelector('.consultation-popup').classList.add('popupopen');
//   var url = window.location.href;
//   document.querySelector('#product_url').value = url;
//   document.querySelector('body').classList.add('overflow_hidden');
// });
//   document.querySelector('.close-consultation-popup').addEventListener("click",(e) => {
//     e.preventDefault();
//     document.querySelector('.consultation-popup').classList.remove('popupopen');
//     document.querySelector('body').classList.remove('overflow_hidden');
//   });

// $('.product_form').on('click',function(){
//   var spreadsheetID = "1DzitcEBrcD0D-p-_wBfCrDRLW6_fWpjro9UWaUZpkHw";
// var url = "https://spreadsheets.google.com/feeds/cells/" + spreadsheetID + "/1/public/values?alt=json-in-script"; //this is the part that's changed
// $.getJSON(url, function(data) {
//     var entry = data.feed.entry;
//      alert(entry)                 
// //     $(entry).each(function(){
// //     //make sure this matches your column labels when you change the source sheet
// //     $('.results').prepend('<h2>'+this.gsx$title.$t+'</h2><p>'+this.gsx$url.$t+'</p>');
// //       });

//     });

// });
function addToCartonlySuccess(){
  $.get("/cart",function(data){
    var html = $(data).find('.checkout').html();
    $('.checkout').html(html);
  });
}
$('body').on('click', '.cart-wrappppper .cart-qut-btn',function(){
  var input = $(this).parent().find('input');
  var ip = parseInt(input.val());
  if($(this).hasClass('cart-plus')) {
    ip += 1;
  } else {
    ip = ip - 1;
  }
  if(ip==0) {
    return false;
  }
  input.val(ip);
  console.log(ip)
  var id = parseInt(input.attr('data-id'));
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates['+id+']='+ip,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      alert(response.description);
    }
  }).done(function(data) {
    addToCartonlySuccess();
    $.getJSON('/cart.js', function(c){
      $('.itemCount').text(c.item_count);
    });
    $.getJSON('/cart.js', function(c){
      var tp=c.original_total_price/100;
      var n=tp.toFixed(2);
      $('.js-ajax-cart-counter').text(c.item_count);
      $('.tprice').text('Rs. '+ n);
    });
    $('.cart-body').removeClass('loading');
  });

});

$("body").on('click','.remove', function(e){  
  e.preventDefault();
  var id = $(this).data("id");
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: 'updates['+id+']='+0,
    dataType: 'json',
    error: function(jqXHR, textStatus, errorThrown){
      var response = $.parseJSON(jqXHR.responseText);
      alert(response.description);
    }
  }).done(function( data ) {
    $.getJSON('/cart.js', function(c){
      if(!c.item_count || c.item_count == 0) {
        $('.cart-wrappppper').empty();
        $('.cart-wrappppper').append('<p class="emptyCart text-center">You have no items in your shopping cart.</p>');    
        $('.cart-wrappppper').removeClass('loading');

        var tp=c.original_total_price/100;
        var n=tp.toFixed(2);
        $('.js-ajax-cart-counter').text(c.item_count);
        $('.tprice').text('Rs. '+ n);
      } else {
        addToCartonlySuccess();
        var tp=c.original_total_price/100;
        var n=tp.toFixed(2);
        $('.js-ajax-cart-counter').text(c.item_count);
        $('.tprice').text('Rs. '+ n);
      }
    });
  });

});
